import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { LazyLoad } from '@/shared/components/LazyLoad';

/*
  The landing decides between the wizard and the organization card; it imports the wizard page itself, so
  both stay in this one lazy chunk.
*/
const OrganizationSetupLandingPage = lazy(() => import('./common/pages/OrganizationSetupLandingPage'));
const OrganizationSetupCompletedPage = lazy(
  () => import('./common/pages/OrganizationSetupCompletedPage'),
);

/**
 * Paths are relative — protectedRoutes.tsx nests these under the
 * admin-guarded branch inside Layout, so they must not start with "/".
 */
export const organizationSetupRoutes: RouteObject[] = [
  {
    path: 'organization-setup',
    children: [
      {
        index: true,
        element: (
          <LazyLoad>
            <OrganizationSetupLandingPage />
          </LazyLoad>
        ),
      },
      {
        path: 'completed',
        element: (
          <LazyLoad>
            <OrganizationSetupCompletedPage />
          </LazyLoad>
        ),
      },
    ],
  },
];
